<div mat-dialog-title class="modal-title">
  <mat-icon>person_pin_circle</mat-icon>
  <span>{{ !editMode ? 'Nuevo pago' : 'Editar pago' }}</span>
  <mat-icon class="close-button" (click)="confirmCloseModal()"> cancel </mat-icon>
</div>
<mat-dialog-content>
  <form [formGroup]="paymentForm" autocomplete="off">
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>Nombre del pago</mat-label>
        <input matInput placeholder="Ej: Pago de Enero" formControlName="name" name="name" autocomplete="off" />
        <mat-error>Nombre del pago requerido</mat-error>
      </mat-form-field>
    </div>
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Fecha de inicio</mat-label>
            <input matInput type="date" placeholder="Fecha de inicio" formControlName="startDate" name="startDate" autocomplete="off" />
            <mat-error>Fecha de inicio requerido</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-control">
          <mat-form-field color="primary" appearance="outline">
            <mat-label>Fecha de finalización</mat-label>
            <input matInput type="date" placeholder="Fecha de finalización" formControlName="endDate" name="endDate" autocomplete="off" />
            <mat-error>Fecha de finalización requerida</mat-error>
          </mat-form-field>
        </div>
      </div>
    </div>
    <div class="form-control">
      <mat-form-field color="primary" appearance="outline">
        <mat-label>Total a pagar</mat-label>
        <input matInput type="number" placeholder="Total a pagar" formControlName="totalToPay" name="totalToPay" autocomplete="off" />
        <mat-error>Mínimo 0</mat-error>
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button color="primary" (click)="confirmCloseModal()"> Cerrar </button>
  <button mat-flat-button color="primary" (click)="saveAffiliatePayment()" [disabled]="paymentForm.invalid || isSavingPayment">
    @if (!isSavingPayment) {
      <span>Guardar</span>
    } @else {
      <mat-spinner class="white-spinner"></mat-spinner>
    }
  </button>
</mat-dialog-actions>
